import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/teamAllocations/styles.scss';export default {
  "footer": "_footer_aqxe3_1"
};